module.exports = __webpack_public_path__ + "9f85c807c943fe5540c08d788b870c17.pdf";